const carouselItems = [
  {
    id: 1,
    tag: '独家专题',
    title: '2026上半年娱乐圈十大未解之谜',
    desc: '盘点今年上半年那些至今没有答案的娱乐圈悬案，从失踪艺人到神秘恋情，带你逐一回顾。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20entertainment%20industry%20editorial%20visual%20with%20question%20marks%20and%20silhouettes%2C%20dramatic%20warm%20lighting%2C%20coral%20pink%20and%20deep%20amber%20tones%2C%20magazine%20feature%20cover%20style%2C%20professional%20quality&width=800&height=500&seq=carousel-01-cg&orientation=landscape',
  },
  {
    id: 2,
    tag: '深度盘点',
    title: '从顶流到素人：那些一夜翻车的网红们',
    desc: '深度分析近三年网红翻车事件的共同规律，从税务问题到人设崩塌，网红经济的暗面全解析。',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20dramatic%20downfall%20editorial%20visual%2C%20broken%20smartphone%20screen%20aesthetic%2C%20warm%20coral%20and%20dark%20amber%20tones%2C%20magazine%20feature%20style%2C%20professional%20quality&width=800&height=500&seq=carousel-02-cg&orientation=landscape',
  },
  {
    id: 3,
    tag: '独家揭秘',
    title: '综艺节目幕后：你看到的和真实发生的',
    desc: '多位综艺幕后工作人员匿名爆料，揭示热门综艺的剪辑逻辑、剧本痕迹与真实录制过程。',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20behind%20the%20scenes%20editorial%20visual%2C%20film%20set%20with%20cameras%20and%20lights%2C%20warm%20golden%20and%20coral%20tones%2C%20documentary%20magazine%20style%2C%20professional%20quality&width=800&height=500&seq=carousel-03-cg&orientation=landscape',
  },
  {
    id: 4,
    tag: '年度总结',
    title: '2026吃瓜年鉴：每月必看大事件回顾',
    desc: '从1月到7月，按月整理2026年最值得记住的吃瓜大事件，一份在手全年吃瓜不遗漏。',
    image: 'https://readdy.ai/api/search-image?query=Year%20in%20review%20entertainment%20collage%20editorial%20visual%2C%20timeline%20with%20vibrant%20highlights%2C%20warm%20coral%20and%20golden%20amber%20tones%2C%20magazine%20annual%20special%20style%2C%20professional%20quality&width=800&height=500&seq=carousel-04-cg&orientation=landscape',
  },
  {
    id: 5,
    tag: '人物特写',
    title: '娱乐圈最强公关团队排名与案例分析',
    desc: '揭秘娱乐圈背后的公关力量，分析近期几起重大危机公关事件的操作手法与最终效果。',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20PR%20crisis%20management%20editorial%20visual%2C%20modern%20office%20with%20dramatic%20lighting%2C%20warm%20coral%20and%20cream%20tones%2C%20business%20magazine%20feature%20style%2C%20professional%20quality&width=800&height=500&seq=carousel-05-cg&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            精选深度专题内容，51吃瓜网站带你深入吃瓜第一线
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}